// custom scrollbar calculations
export function onOptionsScroll(optionsInner, scrollbar, scrollbarThumb) {
  const childrenHeight = getChildrenHeight(optionsInner);
  const scrollTop = optionsInner.scrollTop;
  const optionsInnerHeight = optionsInner?.offsetHeight;
  const maximumScrollTop = childrenHeight - optionsInnerHeight;
  const scrollBarHeight = scrollbar.offsetHeight;
  const scrollBarThumbHeight = scrollbarThumb.offsetHeight;

  scrollbarThumb.style.top =
    (scrollTop / maximumScrollTop) * (scrollBarHeight - scrollBarThumbHeight) +
    "px";
}

export function calculateScrollThumbHeight(
  optionsInner,
  scrollbar,
  scrollbarThumb,
  setHeightFunction
) {
  const childrenHeight = getChildrenHeight(optionsInner);
  const optionsInnerHeight = optionsInner?.offsetHeight;
  const scrollbarHeight = scrollbar?.offsetHeight;

  if (setHeightFunction) {
    setHeightFunction(childrenHeight, optionsInnerHeight, scrollbarHeight);
  } else {
    scrollbarThumb.style.height =
      (optionsInnerHeight / childrenHeight) * scrollbarHeight + "px";
  }
}

function getChildrenHeight(element) {
  let childrenHeight = 0;
  Array.from(element.children)
    .filter((child) => child.classList.contains("input-group__select-option"))
    .forEach((child) => (childrenHeight += getElementOuterHeight(child)));

  return childrenHeight;
}

function getElementOuterHeight(element) {
  const height = element.offsetHeight,
    style = getComputedStyle(element);

  return ["top", "bottom"]
    .map((side) => parseInt(style[`margin-${side}`]))
    .reduce((total, side) => total + side, height);
}
